import { render, staticRenderFns } from "./suporte-hospitais.vue?vue&type=template&id=6aed25be"
import script from "./suporte-hospitais.vue?vue&type=script&lang=ts"
export * from "./suporte-hospitais.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports